const TOKEN_KEY = "kk_hub_token";

export function getStoredToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearStoredToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

/** header ที่ API ส่ง token ต่ออายุกลับมา — ต้องตรงกับ REFRESHED_TOKEN_HEADER ฝั่ง API (sessionToken.ts) */
export const REFRESHED_TOKEN_HEADER = "X-Refreshed-Token";

/**
 * รับ token ต่ออายุจากคำตอบ API (ใช้งานอยู่ = ต่ออายุเอง · ไม่ได้ใช้งานนานเกินที่ตั้งไว้ถึงต้องเข้าใหม่)
 * เก็บเฉพาะเมื่อที่เก็บยังเป็น token ที่ส่งไปจริง — ถ้าเปลี่ยนไปแล้ว (ออกจากระบบ / เข้าใหม่ /
 * แท็บอื่นต่ออายุไปก่อน) ไม่ทับ · token เดิมของแท็บอื่นยังใช้ได้จนหมดอายุของมันเอง
 */
export function adoptRefreshedToken(res: Response, usedToken: string | null | undefined): void {
  const fresh = res.headers.get(REFRESHED_TOKEN_HEADER);
  if (!fresh || !usedToken || getStoredToken() !== usedToken) return;
  setStoredToken(fresh);
}
